export const PLACEHOLDER = '___________'
export const PROD_CLIENT_ID = '2aa2e1efe35245b485fadcb1a34dcd4c'
export const TEST_CLIENT_ID = 'e5228b5481274b5e8db38f181e7ae3b4'


export enum UserRoles {
    ADMIN = 'Admin'
}

export const PROD_HOSTS: readonly string[] = [
    'cdcalendar.lmru.tech',
    'cdcalendar.lemanapro.ru',
    'lmru-cdcalendar-chara-a.apps.lmru.tech',
    'pmof-supplier-calendar.scdp.lmru.tech',
    'pmof-supplier-calendar-os1c-alrakis-prod-01.apps.lmru.tech'
]
